import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "../../components/navbar";
import Sidebar from "../../components/Sidebar";
// import Footer from "components/footer/Footer";
import { useSelector } from "react-redux";
// Admin Imports
import MainDashboard from "views/admin/default";
import Profile from "views/admin/profile";
// import DataTables from "views/admin/tables";
import SignIn from "views/auth/SignIn";
import UserAdd from "views/admin/user/UserAdd";
import BookingForm from "views/admin/BookingForm/BookingForm";
import Bookings from "views/admin/BookingForm/Bookings";
import User from "views/admin/user/User";
import UserEdit from "views/admin/user/UserEdit";
import UserDelete from "views/admin/user/UserDelete";
import BookingFormEdit from "views/admin/BookingForm/BookingFormEdit";
import BlogsFormEdit from "views/blogs/BlogFormEdit";
import CsvUpload from "views/admin/ticketCsv/DataPreview";
import ParentsArenaCourse from "views/admin/parentsArena/cources";
import BlogDelete from "views/blogs/DeleteBlog";
import Campane from 'views/admin/campane'
// Icon Imports
import { MdHome, MdOutgoingMail, MdPerson, MdOutlineFlightTakeoff } from "react-icons/md";
import { ImBlog } from "react-icons/im";
import { FaUserFriends } from "react-icons/fa";
import { AiOutlineLogout } from "react-icons/ai";
import SignOut from "views/auth/SignOut";
import BlogsForm from "views/blogs/BlogsForm";
import Blogs from "views/blogs/Blogs";
import BookingDelete from "views/admin/BookingForm/BookingDelete";
import { getUserDataByToken } from "proxyUrl";
import ErrorPaheInner from "views/ErrorPaheInner";
import axios from "axios";

import Category from "views/admin/category/category";
import CategoryAdd from "views/admin/category/CategoryAdd";
import CategoryEdit from "views/admin/category/CategoryEdit";
import CategoryDelete from "views/admin/category/CategoryDelete";
import ParentsArenaCourseAdd from "views/admin/parentsArena/CourceAdd";
import ParentsArenaCourseEdit from "views/admin/parentsArena/CourceEdit";
import ParentsArenaCourseDelete from "views/admin/parentsArena/CourceDelete";

export default function Admin(props) {
  const user = useSelector((state) => state);

  const [permission, setPermission] = useState();

  // const userDataByApi = async () => {
  //   await axios
  //     .get(getUserDataByToken,
  //       { token: user?.user?.user },
  //       {
  //       withCredentials: true,
  //     })
  //     .then((res) => {
  //       setPermission(res.data.user.userPermission)
  //       return res;
  //     });
  // };
  const userDataByApi = async () => {
    try {
      const res = await axios.get(getUserDataByToken, {
        headers: {
          Authorization: `Bearer ${user?.user?.user?.token}`,
        },
        withCredentials: true,
      });
      // setPermission(res.data.user.userPermission);
      setPermission(res.data.user.user.userPermission);
    } catch (err) {
      console.error("Failed to fetch user info", err);
    }
  };

  useEffect(() => {
    getActiveRoute(routesLinks);
    userDataByApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // generate routes ***************************
  const routesLinks = [
    {
      name: "Dashboard",
      layout: `/admin`,
      path: "dashboard",
      icon: <MdHome className="h-6 w-6" />,
      display: "",
      component: <MainDashboard />,
    },
    {

      name: "Ticket Upload",
      layout: `/${`admin`}`,
      path: "ticketupload",
      display: "",
      icon: <ImBlog className="h-6 w-6" />,
      component: <CsvUpload />,

    },
    {
      name: "Category",
      layout: `/${`admin`}`,
      path: "category",
      display: "",
      icon: <FaUserFriends className="h-6 w-6" />,
      component: <Category />,
    },
    {
      name: "Add Category",
      layout: `/${`admin`}`,
      path: "category/add",
      display: "hidden",
      icon: "",
      component: <CategoryAdd />,
    },
    {
      name: "edit category",
      layout: `/${`admin`}`,
      path: "category/edit/:id",
      display: "hidden",
      icon: "",
      component: <CategoryEdit />,
    },
    {
      name: "delete category",
      layout: `/${`admin`}`,
      path: "category/delete/:id",
      display: "hidden",
      icon: "",
      component: <CategoryDelete />,
    },
    {

      name: "Parents Arena Course",
      layout: `/${`admin`}`,
      path: "parents-arena-course",
      display: "",
      icon: <ImBlog className="h-6 w-6" />,
      component: <ParentsArenaCourse />,

    },
    
    {
      name: "Add Parents Arena Course",
      layout: `/${`admin`}`,
      path: "parents-arena-course/add",
      display: "hidden",
      icon: "",
      component: <ParentsArenaCourseAdd />,
    },
    {
      name: "edit Parents Arena Course",
      layout: `/${`admin`}`,
      path: "parents-arena-course/edit/:id",
      display: "hidden",
      icon: "",
      component: <ParentsArenaCourseEdit />,
    },
    {
      name: "delete Parents Arena Course",
      layout: `/${`admin`}`,
      path: "parents-arena-course/delete/:id",
      display: "hidden",
      icon: "",
      component: <ParentsArenaCourseDelete />,
    },
  ];
  const logged_user_info = useSelector((state) => state.user.user);
  if (!logged_user_info.userPermission) {
  }
  const userPermissions = logged_user_info.userPermission
    ? logged_user_info.userPermission
    : permission;
  console.log(permission, 'permission');
  if (userPermissions) {
    userPermissions.forEach((element) => {
      if (element === "BookingAdd") {
        routesLinks.push({
          name: "Bookings",
          layout: `/${`admin`}`,
          path: "bookings",
          display: "",
          icon: <MdOutlineFlightTakeoff className="h-6 w-6" />,
          component: <Bookings />,
        });
        routesLinks.push({
          name: "add bookings",
          layout: `/${`admin`}`,
          path: "bookings/add",
          display: "hidden",
          icon: "",
          component: <BookingForm />,
        });
      } else if (element === "BookingEdit") {
        routesLinks.push({
          name: "BookingEdit",
          layout: `/${`admin`}`,
          path: "bookings/edit/:id",
          display: "hidden",
          icon: <MdOutlineFlightTakeoff className="h-6 w-6" />,
          component: <BookingFormEdit />,
        });
      } else if (element === "BookingDelete") {
        routesLinks.push({
          name: "BookingDelete",
          layout: `/${`admin`}`,
          path: "bookings/delete/:id",
          display: "hidden",
          icon: <MdOutlineFlightTakeoff className="h-6 w-6" />,
          component: <BookingDelete />,
        });
      } else if (element === "userAdd") {
        routesLinks.push(
          {
            name: "Users",
            layout: `/${`admin`}`,
            icon: <FaUserFriends className="h-6 w-6" />,
            path: "users",
            display: "",
            component: <User />,
          },
          {
            name: "add user",
            layout: `/${`admin`}`,
            path: "users/add",
            display: "hidden",
            icon: "",
            component: <UserAdd />,
          }
        );
      } else if (element === "userEdit") {
        routesLinks.push({
          name: "edit user",
          layout: `/${`admin`}`,
          path: "users/edit/:id",
          display: "hidden",
          icon: "",
          component: <UserEdit />,
        });
      } else if (element === "userDelete") {
        routesLinks.push({
          name: "edit user",
          layout: `/${`admin`}`,
          path: "users/delete/:id",
          display: "hidden",
          icon: "",
          component: <UserDelete />,
        });
      }

      // Category routes are now always available in the base routesLinks array
      // 

      else if (element === "blog") {
        routesLinks.push(
          {
            name: "Blogs",
            layout: `/${`admin`}`,
            path: "blogs",
            display: "",
            icon: <ImBlog className="h-6 w-6" />,
            component: <Blogs />,
          },
          {
            name: "BlogAdd",
            layout: `/${`admin`}`,
            path: "blogs/add",
            display: "hidden",
            icon: <ImBlog className="h-6 w-6" />,
            component: <BlogsForm />,
          },
          {
            name: "BlogEdit",
            layout: `/${`admin`}`,
            path: "blogs/edit/:id",
            display: "hidden",
            icon: <ImBlog className="h-6 w-6" />,
            component: <BlogsFormEdit />,
          },

          {
            name: "BlogDelete",
            layout: `/${`admin`}`,
            path: "blogs/delete/:id",
            display: "hidden",
            icon: <ImBlog className="h-6 w-6" />,
            component: <BlogDelete />,
          }
        );
      }
      else if (element === "emailcampaign") {
        routesLinks.push(
          {
            name: "Email Campaign",
            layout: `/${`admin`}`,
            path: "emailcampaign",
            display: "",
            icon: <MdOutgoingMail className="h-6 w-6" />,
            component: <Campane />,
          }

        );
      }
    });
  }
  routesLinks.push(
    {
      name: "Profile",
      layout: `/${`admin`}`,
      path: "profile",
      display: "",
      icon: <MdPerson className="h-6 w-6" />,
      component: <Profile />,
    },
    {
      name: "Log In",
      layout: "/auth",
      path: "sign-in",
      display: "hidden",
      icon: <AiOutlineLogout className="h-6 w-6" />,
      component: <SignIn />,
    },
    {
      name: "Log Out",
      layout: "/auth",
      path: "sign-out",
      display: "",
      icon: <AiOutlineLogout className="h-6 w-6" />,
      component: <SignOut />,
    }
  );

  // generate routes ***************************

  console.log(routesLinks, 999);
  const { ...rest } = props;
  const [open, setOpen] = useState(true);

  const [currentRoute, setCurrentRoute] = useState("Dashboard");

  useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);



  const getActiveRoute = (routes) => {
    let activeRoute = "Dashboard";
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(
          routes[i].layout + "/" + routes[i].path
        ) !== -1
      ) {
        setCurrentRoute(routes[i].name);
      }
    }
    return activeRoute;
  };

  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };



  document.documentElement.dir = "ltr";
  return (
    <div className="flex h-full w-full bg-gray-200 pb-8 ">
      {/* <div className="w-full h-9 z-30 bg-navy-600 fixed"></div> */}
      <Sidebar
        open={open}
        routes={routesLinks}
        onClose={() => setOpen(false)}
      />
      {/* Navbar & Main Content */}
      <div className="h-full w-full  dark:!bg-navy-900">
        {/* Main Content */}
        <main
          className={`mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]`}
        >
          {/* Routes */}
          <div className="h-full">
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              logoText={"Flio Travel"}
              brandText={currentRoute}
              secondary={getActiveNavbar(routesLinks)}
              {...rest}
            />
            <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
              <Routes>
                {routesLinks.map((prop, key) => {
                  return (
                    <Route
                      path={`/${prop.path}`}
                      element={prop.component}
                      key={key}
                    />
                  );
                })}
                <Route
                  path="/auth/sign-in"
                  element={<navigate to="/admin/Dashboard" replace />}
                />
                <Route
                  path="/*"
                  element={<ErrorPaheInner />}
                />
              </Routes>
            </div>
            {/* <div className="p-3">
              <Footer />
            </div> */}
          </div>
        </main>
      </div>
    </div>
  );
}
